import React, { useCallback, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import { API_BASE_URL, API_ORIGIN } from '../api';
import InvoicePayView from '../components/portal/InvoicePayView';
import PublicBrandHeader from '../components/public/PublicBrandHeader';
import PublicBrandShell from '../components/public/PublicBrandShell';

export default function PublicPayInvoice() {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const paidSuccess = searchParams.get('paid') === '1';
  const [brand, setBrand] = useState(null);

  const fetchInvoice = useCallback(async () => {
    const res = await fetch(`${API_BASE_URL}public/pay/invoice/${token}`, {
      headers: { Accept: 'application/json' },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.message || `HTTP ${res.status}`);
    if (json.brand) setBrand(json.brand);
    return json;
  }, [token]);

  const onCheckout = useCallback(
    async (successUrl, cancelUrl) => {
      const res = await fetch(`${API_BASE_URL}public/pay/invoice/${token}/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ success_url: successUrl, cancel_url: cancelUrl }),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.message || `HTTP ${res.status}`);
      return json;
    },
    [token]
  );

  useEffect(() => {
    document.title = 'Pay invoice';
    return () => {
      document.title = 'WorkWiseSoft';
    };
  }, []);

  return (
    <PublicBrandShell embeddedBrand={brand}>
    <Box sx={{ py: { xs: 2, md: 4 }, px: 2 }}>
      <Box sx={{ maxWidth: 720, mx: 'auto' }}>
        <PublicBrandHeader
          subtitle={
            paidSuccess
              ? 'Payment received — thank you'
              : 'Pay securely by card or use the bank details below'
          }
        />
        {paidSuccess ? (
          <Typography variant="body2" color="success.main" sx={{ textAlign: 'center', mb: 2 }}>
            It may take a moment to update your invoice status.
          </Typography>
        ) : null}
        <InvoicePayView
          fetchInvoice={fetchInvoice}
          onCheckout={onCheckout}
          pdfHref={`${API_ORIGIN}/api/public/pay/invoice/${token}/pdf`}
        />
      </Box>
    </Box>
    </PublicBrandShell>
  );
}
